const Elements = {
    "lightning": {
        "name": "Lightning",
        "color": "#FAB536",
        // "icon": require("@frog/source/assets/images/elements/Lightning.png"),
        // "icon": require("@frog/source/assets/images/pokemon/icons/types/electric.png"),
        "strengths": ["water", "metal"],
        "weaknesses": ["grass", "ground"],
        "color": "#EDAE49",
    },
    "water": {
        "name": "Water",
        "color": "#5BC7E5",
        // "icon": require("@frog/source/assets/images/elements/Water.png"),
        // "icon": require("@frog/source/assets/images/pokemon/icons/types/water.png"),
        "strengths": ["fire", "ground"],
        "weaknesses": ["grass", "lightning"],
        "color": "#2274A5",
    },
    "ground": {
        "name": "Ground",
        "color": "#A63414",
        // "icon": require("@frog/source/assets/images/elements/Ground.png"),
        // "icon": require("@frog/source/assets/images/pokemon/icons/types/ground.png"),
        "strengths": ["fire", "lightning"],
        "weaknesses": ["water", "metal"],
        "color": "#946846"
    },
    "fire": {
        "name": "Fire",
        "color": "#E24242",
        // "icon": require("@frog/source/assets/images/elements/Fire.png"),
        // "icon": require("@frog/source/assets/images/pokemon/icons/types/fire.png"),
        "strengths": ["grass", "metal"],
        "weaknesses": ["water", "ground"],
        "color": "#D05353",
    },
    "metal": {
        "name": "Metal",
        "color": "#8A776E",
        // "icon": require("@frog/source/assets/images/elements/Metal.png"),
        // "icon": require("@frog/source/assets/images/pokemon/icons/types/steel.png"),
        "strengths": ["grass", "ground"],
        "weaknesses": ["fire", "lightning"],
        "color": "#3D314A",
    },
    "grass": {
        "name": "Grass",
        "color": "#7DB808",
        // "icon": require("@frog/source/assets/images/elements/Grass.png"),
        // "icon": require("@frog/source/assets/images/pokemon/icons/types/grass.png"),
        "strengths": ["water", "lightning"],
        "weaknesses": ["fire", "metal"],
        "color": "#9FD356",
    },
    "neutral": {
        // "name": "Neutral",
        "name": "No",
        "color": "#FFFFFF",
        // "icon": require("@frog/source/assets/images/elements/Neutral.png"),
        // "icon": require("@frog/source/assets/images/pokemon/icons/types/normal.png"),
        "strengths": [],
        "weaknesses": [],
        "color": "#F0EAD6",
    },
}

const aliases = [
    {"from": "electric", "to": "lightning"},
    {"from": "steel", "to": "metal"},
    {"from": "leaf", "to": "grass"},
    {"from": "wood", "to": "grass"},
]

Object.values(Elements).forEach((element) => {
    element.icon = element.icon && element.icon.default
    element._weaknesses = Array.from(element.weaknesses)
    element._strengths = Array.from(element.strengths)
})

aliases.forEach((alias) => {
    Elements[alias.from] = Elements[alias.to]
    Object.values(Elements).forEach((element) => {
        if(element._strengths.includes(alias.to)) {
            element._strengths.push(alias.from)
        }
        if(element._weaknesses.includes(alias.to)) {
            element._weaknesses.push(alias.from)
        }
    })
})

// Lightning
// // background-color: #F7D02C;
// background-color: #FAB536; // tcg lightning color
// // background-color: #A37523; // tcg lightning dark color
// // background-color: #FCCE7C; // tcg lightning light color

// Water
// // background-color: #6390F0; // water color
// background-color: #5BC7E5; // tcg water color
// // background-color: #3B8295; // tcg water dark color
// // background-color: #94DBEE; // tcg water light color

// Ground
// // background-color: #E2BF65; // ground color
// // background-color: #B6A136; // rock color
// // background-color: #FF501F; // tcg fighting color
// background-color: #A63414; // tcg fighting dark color
// // background-color: #FF8D6D; // tcg fighting light color

// Fire
// // background-color: #EE8130; // fire color
// background-color: #E24242; // tcg fire color
// // background-color: #932B2B; // tcg fire dark color
// // background-color: #EC8484; // tcg fire light color

// Metal
// // background-color: #B7B7CE; // steel color
// background-color: #8A776E; // tcg metal color
// // background-color: #5A4D48; // tcg metal dark color
// // background-color: #B3A6A1; // tcg metal light color

// Grass
// // background-color: #7AC74C; // grass color
// background-color: #7DB808; // tcg grass color
// // background-color: #517805; // tcg grass dark color
// // background-color: #AAD15E; // tcg grass light color

Elements.getEffectiveness = function(defensiveElements, offensiveElements) {
    defensiveElements = defensiveElements instanceof Array ? defensiveElements : [defensiveElements]
    offensiveElements = offensiveElements instanceof Array ? offensiveElements : [offensiveElements]

    if(Elements[offensiveElements[0]] == undefined) {
        return 0
    }
    if(Elements[offensiveElements[0]]._strengths.includes(defensiveElements[0])) {
        return +1
    }
    if(Elements[offensiveElements[0]]._weaknesses.includes(defensiveElements[0])) {
        return -1
    }
    return 0
}

Elements.getDamage = function(defensiveElements, offensiveElements, potency) {
    const effectiveness = Elements.getEffectiveness(defensiveElements, offensiveElements)

    if(potency == "mad") {
        if(effectiveness < 0) return +2
        if(effectiveness > 0) return -2
        return 0
    }
    if(potency == "mild") {
        if(effectiveness < 0) return +1
        if(effectiveness > 0) return -1
        return 0
    }

    // potency == "standard"
    if(effectiveness < 0) return 0 // +0.5
    if(effectiveness > 0) return -1
    return 0
}

export default Elements
